var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserIcon = function SvgUserIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 22.379c0-4.418-3.626-8-8.1-8h-1.8c-4.474 0-8.1 3.582-8.1 8m9-11a4 4 0 0 1-4-4v-1a4 4 0 1 1 8 0v1a4 4 0 0 1-4 4"
  })));
};
export default SvgUserIcon;